import React from 'react'
import { BeWizrLibraryTopic } from '~/models'
import { memo } from '~/ui/component'
import { ListBar, SVG } from '~/ui/components'
import { layout } from '~/ui/styling'
import { register } from './registry'

export interface Props {
  item: BeWizrLibraryTopic
}

const BeWizrLibraryTopicSearchResult = memo('BeWizrLibraryTopicSearchResult', (props: Props) => {

  const {item} = props

  //------
  // Rendering

  function render() {
    return (
      <ListBar
        href={`//bewizr-topics/${item.id}`}
        caption={item.title}
        image={item.links.image == null ? 'archive' : {type: 'remote', url: item.links.image}}
        accessory={<SVG name='chevron-right' size={layout.icon.m} dimmer/>}
      />
    )
  }

  return render()

})

register('bewizr-topics', BeWizrLibraryTopicSearchResult)